<template>
    <div>
        <form @submit.prevent class="m-form" name="generalDamages">
            <div v-for="(award, awardIndex) in getAwards">
                <award :awardIndex="awardIndex" :award="award" v-on:award-selected="selectedAward"></award>
            </div>
            <button v-if="getTree !== null" class="a-button" @click="addAward">Add Another Award</button>

            <div class="p-pi-income" v-if="getTree !== null" >
                <h2>General Damages Totals</h2>
                <div class="a-table a-table--short-no-style a-table--full-width u-margin-top-20">
                    <table cellspacing="0" cellpadding="0" class="a-table--full-width">
                        <thead>
                            <tr>
                                <th style="width: 500px">Award</th>
                                <th>JC Guidelines Chapter</th>
                                <th>General Damages Award</th>
                                <th>Discount %</th>
                                <th>Sub Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <award-value-row v-for="(award, awardIndex) in getAwards" :key="awardIndex" :award-index="awardIndex"></award-value-row>
                        </tbody>
                        <tfoot>
                            <tr class="a-table--grey">
                                <td class="u-text-right u-bold" colspan="4">
                                    General Damages Total (100%)
                                </td>
                                <td>{{ currencyFormat(getSubTotal) }}</td>
                            </tr>
                            <tr class="a-table--grey">
                                <td class="u-text-right u-bold" colspan="4">
                                    General Damages Total (Discounted)
                                </td>
                                <td>{{ currencyFormat(getSubTotalDiscounted) }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </form>

        <step-button :next-valid="isValid()"></step-button>
    </div>
</template>
<script>

    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import FormValidator from 'components/form/validator/mixin';
    import StepButton from 'components/StepButton.vue';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import { setStepValid }  from 'services/routingMethods';
    import { mapGetters, mapActions } from 'vuex';
    import InjurySelect from 'pages/personal-injury-claims/components/InjurySelect.vue';
    import Award from "./awards/Award";
    import currencyFormat from 'mixins/currencyFormat';
    import AwardValueRow from './awards/AwardValueRow.vue';

    export default {
        name: 'general-damages',
        computed: {
            ...mapGetters('personal/generalDamages', {
                getTree: 'getTree',
                getAward: 'getAward',
                getAwards: 'getAwards',
                getSubTotal: 'getSubTotal',
                getAwardsValid: 'getAwardsValid',
                getDiscountsValid: 'getDiscountsValid',
                getGeneralDamages: 'getGeneralDamages',
                getJCGuidelinesInfo: 'getJCGuidelinesInfo',
                getJCGuidelinesNames: 'getJCGuidelinesNames',
                getSubTotalDiscounted: 'getSubTotalDiscounted'
            })
        },
        mounted() {
            this.fetchInjuries();
        },
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        mixins: [
            FormValidator,
            currencyFormat
        ],
        components: {Award, StepButton, Control, ControlError, InjurySelect, AwardValueRow },
        methods: {
            ...mapActions('personal/generalDamages', {
                fetchInjuries: 'fetchInjuries',
                addAward: 'addAward'
            }),
            updateValid() {
                setStepValid(this.isValid());
            },
            isValid() {
                return this.$valid() && this.getAwardsValid;
            },
            selectedAward() {
                this.updateValid();
            },
        }
    }
</script>





// WEBPACK FOOTER //
// GeneralDamages.vue?0e384620